import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import Routes from './pages/routes';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import { TasksProvider } from './contexts/tasks.context';
import { ChatProvider } from './contexts/chat.context';
import { MeetProvider } from './contexts/meeting.context';
import { ThemeProvider } from './contexts/theme.context';
import { AuthProvider } from './contexts/auth.context';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <TasksProvider>
            <ChatProvider>
              <MeetProvider>
                <Routes />
              </MeetProvider>
            </ChatProvider>
          </TasksProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);

